/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Cta_PInputs */

const es_landing_cta_p = /** @type {(inputs: Landing_Cta_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuéntanos cómo es tu barco y te decimos qué podría ganar. Sin compromiso.`)
};

const gl_landing_cta_p = /** @type {(inputs: Landing_Cta_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cóntanos como é o teu barco e dicímosche o que podería gañar. Sen compromiso.`)
};

const en_landing_cta_p = /** @type {(inputs: Landing_Cta_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tell us about your boat and we will estimate what it could earn. No obligation.`)
};

/**
* | output |
* | --- |
* | "Tell us about your boat and we will estimate what it could earn. No obligation." |
*
* @param {Landing_Cta_PInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_cta_p = /** @type {((inputs?: Landing_Cta_PInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Cta_PInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_cta_p(inputs)
	if (locale === "en") return en_landing_cta_p(inputs)
	return es_landing_cta_p(inputs)
});